export default __webpack_public_path__ + "assets/304ac48f0d998c343c02e19d695f0c63.svg";